import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap, timer, concatMap, of, takeUntil, exhaustMap } from "rxjs";
import { API } from "../../shared/api";
import {
    fetchMessageData,
    fetchTrainData,
    pollAllTrainDataSync,
    stopPollingTrainDataSync,
    updateMessageData,
    updateTrainData,
    trainDataError,
    messageDataError
} from "./home.action";

@Injectable()
export class HomeEffects {

    constructor(private actions$: Actions, private api: API) {}

    fetchTrainData$ = createEffect(() => this.actions$.pipe(
        ofType(fetchTrainData),
        exhaustMap(() => this.api.getTrainData().pipe(
            map((trainData) => updateTrainData({ trainData })),
            catchError((error) => {
                console.error('Error fetching train data:', error);
                return of(trainDataError({ error }));
            })
        ))
    ))

    fetchMessageData$ = createEffect(() => this.actions$.pipe(
        ofType(fetchMessageData),
        exhaustMap(() => this.api.getMessageData().pipe(
            map(messageData => updateMessageData({ messageData })),
            catchError((error) => {
                console.error('Error fetching message data:', error);

                return of(messageDataError({ error }));
            })
        ))
    ))

    pollAllTrainDataSync$ = createEffect(() => this.actions$.pipe(
        ofType(pollAllTrainDataSync),
        switchMap(() =>
            timer(0, 10000).pipe(
                concatMap(() => of(
                    fetchMessageData(),
                    fetchTrainData(),
                )),
                takeUntil(this.actions$.pipe(ofType(stopPollingTrainDataSync)))
            )
        )
    ))

}